import React from "react"

import {
  GlobalSearchOption,
  GlobalSearchResultType
} from "../../../../types/GlobalSearch"
import { BuildingReferenceGlobalSearchListItem } from "./BuildingReferenceGlobalSearchListItem"
import { ProductGlobalSearchListItem } from "./ProductGlobalSearchListItem"
import { ProjectGlobalSearchListItem } from "./ProjectGlobalSearchListItem"

interface GlobalSearchListItemFactoryProps {
  option: GlobalSearchOption
  index: number
  isTabActive: boolean
}

export const GlobalSearchListItemFactory = React.memo(
  ({ option, index, isTabActive }: GlobalSearchListItemFactoryProps) => {
    switch (option.type) {
      case GlobalSearchResultType.PRODUCT:
        return (
          <ProductGlobalSearchListItem
            option={option}
            index={index}
            isTabActive={isTabActive}
          />
        )
      case GlobalSearchResultType.PROJECT:
        return (
          <ProjectGlobalSearchListItem
            option={option}
            index={index}
            isTabActive={isTabActive}
          />
        )
      case GlobalSearchResultType.BUILDING_REFERENCE:
        return (
          <BuildingReferenceGlobalSearchListItem
            option={option}
            index={index}
            isTabActive={isTabActive}
          />
        )
      default:
        return null
    }
  }
)
